import Select from "react-select";
import { ClipLoader } from "react-spinners";
import { FaTrash } from "react-icons/fa";
import { BsPauseFill, BsPlayFill } from "react-icons/bs";
import { safeJsonParse } from "./productUtils";

function BeatCard({
  beat,
  audio,
  playingBeat,
  editing,
  editValues,
  editStems,
  saveLoadingId,
  selectedGenres,
  genreOptions,
  styles,
  deleting,

  togglePlay,
  handleEdit,
  handleInputChange,
  handleImageChange,
  handleGenreChange,
  handleAudioUpload,
  handleSave,
  handleDeleteClick,
  setEditStems,
  setViewStems,
}) {
  const isEditing = editing === beat.$id && editValues.type === "beat";
  const parsedStems = safeJsonParse(beat.stems, []);

  return (
    <div className="product-item">
      <div className="product-image-container">
        <img
          src={beat.imageUrl}
          alt={beat.beatName}
          className="product-image"
        />

        <button
          className="yp-beat-play-button"
          onClick={() => togglePlay(beat)}
        >
          {playingBeat && playingBeat.$id === beat.$id && !audio.paused ? (
            <BsPauseFill />
          ) : (
            <BsPlayFill />
          )}
        </button>
      </div>

      {isEditing ? (
        <div>
          <div className="tutorial-yp">
            <p>Beat:</p>
            <input
              type="text"
              name="name"
              value={editValues.name}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>Artist:</p>
            <input
              type="text"
              name="artistName"
              value={editValues.artistName}
              onChange={handleInputChange}
            />
          </div>

          <div className="tutorial-yp">
            <p>Basic₹:</p>
            <input
              type="number"
              name="basicCost"
              value={editValues.basicCost}
              onChange={handleInputChange}
            />

            <p> Prem₹:</p>
            <input
              type="number"
              name="premiumCost"
              value={editValues.premiumCost}
              onChange={handleInputChange}
              disabled={!editStems.some((s) => s.name.trim())}
            />
          </div>

          <div className="tutorial-yp">
            <p>Bpm:</p>
            <input
              type="number"
              name="bpm"
              value={editValues.bpm || ""}
              onChange={handleInputChange}
              placeholder="Tempo(bpm)"
            />
          </div>

          <div className="tutorial-yp">
            <p>Albumart:</p>
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </div>

          <div className="tutorial-yp">
            <p>Genres:</p>
            <Select
              isMulti
              closeMenuOnSelect={false}
              options={genreOptions}
              onChange={handleGenreChange}
              value={selectedGenres}
              placeholder="Edit the Genres"
              classNamePrefix="filter-dropdown"
              className="filter-dropdown"
              styles={styles}
              menuPortalTarget={document.body}
            />
          </div>

          <div className="tutorial-yp">
            <p>Audio:</p>
            <input
              type="file"
              accept="audio/mpeg, audio/wav"
              onChange={(e) => handleAudioUpload(e.target.files[0], beat)}
            />
          </div>

          <div className="tutorial-yp stem-head">
            {beat.stems && (
              <button
                className="view-stems-btn"
                onClick={() => setViewStems(beat)}
              >
                Stems
              </button>
            )}

            <div className="stem-info-all">
              {editStems.length === 0 ? (
                <button
                  type="button"
                  onClick={() => setEditStems([{ name: "", file: null }])}
                  className="add-stem-btn no-stem-add"
                >
                  + Add Stem
                </button>
              ) : (
                editStems.map((stem, index) => (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    <div className="stem-info-add">
                      <input
                        type="text"
                        placeholder="Stem Name (e.g. Kick)"
                        value={stem.name}
                        onChange={(e) => {
                          const updated = [...editStems];
                          updated[index].name = e.target.value;
                          setEditStems(updated);
                        }}
                        style={{ width: "140px", marginRight: "8px" }}
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setEditStems((prev) =>
                            prev.filter((_, i) => i !== index),
                          )
                        }
                        className="remove-stem-btn"
                        title="Remove Stem"
                      >
                        <FaTrash />
                      </button>

                      {index === editStems.length - 1 && (
                        <button
                          type="button"
                          onClick={() =>
                            setEditStems([
                              ...editStems,
                              { name: "", file: null },
                            ])
                          }
                          className="add-stem-btn"
                        >
                          + Add
                        </button>
                      )}
                    </div>

                    <div className="tutorial-yp">
                      <input
                        type="file"
                        accept="audio/wav, audio/mp3"
                        onChange={(e) => {
                          const updated = [...editStems];
                          updated[index].file = e.target.files[0];
                          setEditStems(updated);
                        }}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <button
            className="save-button"
            onClick={() => handleSave(beat)}
            disabled={saveLoadingId === beat.$id}
          >
            {saveLoadingId === beat.$id ? (
              <ClipLoader size={14} color="#fff" />
            ) : (
              "Save"
            )}
          </button>
        </div>
      ) : (
        <div className="yourprod-details">
          <div className="yourprod-detail">
            <p>Beat:</p> {beat.beatName}
          </div>

          <div className="yourprod-detail">
            <p>Artist:</p> {beat.artistName || "Unknown"}
          </div>

          <div className="yourprod-detail">
            <p>Basic Cost : </p> ₹{beat.basicCost}
          </div>

          {parsedStems.length > 0 && (
            <div className="yourprod-detail">
              <p>Premium Cost: </p>₹{beat.premiumCost}
            </div>
          )}

          <div className="yourprod-detail">
            <p>BPM:</p> {beat.bpm}
          </div>

          <div className="yourprod-detail yp-genre">
            <p>Genres:</p> {beat.genre}
          </div>
        </div>
      )}

      <div>
        <button
          className="edit-button"
          onClick={() => handleEdit(beat, "beat")}
        >
          {isEditing ? "Close" : "Edit"}
        </button>

        <button
          className="delete-button"
          onClick={() => handleDeleteClick(beat.$id, "beat")}
          disabled={deleting === beat.$id}
        >
          {deleting === beat.$id ? <ClipLoader size={12} /> : "Delete"}
        </button>
      </div>
    </div>
  );
}

export default BeatCard;
